const initialColorList = [{ title: '', list: [], mixed: false, palette: false }];
const initialStyleGuideOnStage = {
    analysis: {
        mood: null,
        archetypeSuggestions: [],
        activeArchetype: null,
        seed: null,
    },
    sections: [],
    input: {
        colorOnStage: null,
        selectedArchetype: null,
        selectedIntensity: null,
    },
};

export { initialColorList, initialStyleGuideOnStage };
